export enum ChecklistPositionKind {
  DEFAULT = 'DEFAULT',
  HEADLINE = 'HEADLINE',
  EMPTY_ROW = 'EMPTY_ROW',
}
